<template>
  <v-form ref="form" v-model="valid">
    <v-card class="elevation-12">
      <v-toolbar dark color="primary">
        <v-toolbar-title>{{
          $t("resetPasswordForm.changePasswordForUser", [login])
        }}</v-toolbar-title>
        <v-spacer />
      </v-toolbar>
      <v-card-text>
        <v-text-field
          disabled
          prepend-icon="mdi-account"
          name="Login"
          :label="this.$t('resetPasswordForm.login')"
          type="text"
          v-model="login"
          :rules="loginRules"
        />
        <v-text-field
          v-if="!forced"
          prepend-icon="mdi-lock"
          name="previousPassword"
          :label="this.$t('resetPasswordForm.previousPassword')"
          type="password"
          v-model="previous_password"
        />
        <v-text-field
          prepend-icon="mdi-lock"
          name="password"
          :label="this.$t('resetPasswordForm.newPassword')"
          type="password"
          v-model="new_password"
          :rules="newPasswordRules"
        />
        <v-text-field
          prepend-icon="mdi-lock"
          name="passwordConfirm"
          :label="this.$t('resetPasswordForm.newPasswordConfirmation')"
          id="password"
          type="password"
          v-model="new_password_confirmation"
          :rules="newPasswordConfirmationRules"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="primary" @click="onChangePassword" :disabled="!valid">
          {{ this.$t("resetPasswordForm.changePassword") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import { notifyError, notifyWarning } from '@/services/notifications';

export default {
  name: 'ResetPasswordForm',
  props: {
    login: {
      type: String,
      required: true,
    },
    forced: {
      type: Boolean,
      required: true,
      default: false,
    },
    min_symbols_password: {
      type: Number,
      default: 8,
    },
  },
  data() {
    return {
      previous_password: '',
      new_password: '',
      new_password_confirmation: '',
      valid: true,
      permissibleChars: /^[A-Za-z0-9]+$/,
    };
  },
  computed: {
    loginRules() {
      return [(v) => !!v || this.$t('resetPasswordForm.loginIsRequired')];
    },
    previousPasswordRules() {
      return [
        (v) => !!v || this.$t('resetPasswordForm.previousPasswordIsRequired'),
        (v) => v.match(this.permissibleChars) !== null,
        (v) =>
          this.$store.getters.IS_DEBUG ||
          v.length > this.min_symbols_password ||
          this.$t('resetPasswordForm.passwordMustBeBiggerThanNSymbols', [
            this.min_symbols_password,
          ]),
      ];
    },
    newPasswordRules() {
      return [
        (v) => !!v || this.$t('resetPasswordForm.newPasswordIsRequired'),
        (v) =>
          v.length > this.min_symbols_password ||
          this.$t('resetPasswordForm.passwordMustBeBiggerThanNSymbols', [
            this.min_symbols_password,
          ]),
        (v) =>
          this.$store.getters.IS_DEBUG ||
          v.match(this.permissibleChars) !== null ||
          this.$t('resetPasswordForm.unaccepttableSymb'),
        !this.forced
          ? (v) =>
            v !== this.previous_password ||
              this.$t('resetPasswordForm.previousAndNewPasswordCannotBeEquals')
          : () => true,
      ];
    },
    newPasswordConfirmationRules() {
      return [
        (v) =>
          !!v || this.$t('resetPasswordForm.newPasswordConfirmationIsRequired'),
        (v) =>
          v === this.new_password ||
          this.$t('resetPasswordForm.passwordsAreNotEquals'),
      ];
    },
  },
  methods: {
    async onChangePassword() {
      await this.$store
        .dispatch('change_password', {
          data: {
            login: this.login,
            previous_password: this.previous_password,
            new_password: this.new_password,
            new_password_confirmation: this.new_password_confirmation,
            forced: this.forced,
          },
          vm: this,
        })
        .then(async () => {
          if (this.forced) {
            await this.$store.dispatch('login', {
              data: {
                login: this.login,
                password: this.new_password,
              },
              vm: this,
            });
          }
        })
        .then(() => this.$router.push({ path: '/cards' }))
        .catch((err) => {
          console.error(err);
          const { errorType, entity } = err.response.data;

          switch (errorType) {
          case 'NEED_RESET_PASSWORD': {
            notifyWarning('', this.$t('loginForm.needResetPassword'));
            this.$router.push({
              path: '/login',
              query: { mode: 'reset', forced: true, login: this.login },
            });
            break;
          }
          case 'WRONG_PASSWORD': {
            switch (entity) {
            case 'OldPassword': {
              notifyError('', this.$t('Messages.OldPasswordIsEmpty'));
              break;
            }
            case 'NewPassword': {
              notifyError('', this.$t('Messages.NewPasswordIsEmpty'));
              break;
            }
            case 'Old_Password_Is_Not_Correct': {
              notifyError('', this.$t('Messages.OldPasswordIsNotCorrect'));
              break;
            }
            default: {
              notifyError('', this.$t('loginForm.wrongPassword'));
              break;
            }
            }
            break;
          }
          case 'NO_RIGHTS': {
            notifyError('', this.$t('loginForm.noRights'));
            this.$router.push({
              path: '/login',
            });
            break;
          }
          case 'BLOCKED': {
            notifyError('', this.$t('loginForm.blocked'));
            break;
          }

          default: {
            notifyError('', this.$t('Error'));
            break;
          }
          }
        });
    },
  },
};
</script>
